import { render, staticRenderFns } from "./OwnCompanies.vue?vue&type=template&id=744e12a8&"
import script from "./OwnCompanies.vue?vue&type=script&lang=js&"
export * from "./OwnCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports